import { z } from "zod";

// Mirrors the backend PasswordRules guard: min 8 chars, max 72 bytes. BCrypt truncates past 72 bytes,
// so the cap is on UTF-8 byte length, not code units.
const MAX_PASSWORD_BYTES = 72;
const byteLength = (value: string) => new TextEncoder().encode(value).length;

export const newPasswordSchema = z
  .string()
  .min(8, "Minst 8 tecken")
  .refine((v) => byteLength(v) <= MAX_PASSWORD_BYTES, "Högst 72 byte");
